import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from '../menuitem/app.menuitem.component';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  imports: [CommonModule, AppMenuitem, RouterModule],
})
export class AppMenu implements OnInit {
  model: MenuItem[] = [];

  constructor() {}

  ngOnInit() {
    this.llenarMenu();
  }

  llenarMenu() {
    this.model = [
      {
        label: 'INICIO',
        items: [
          {
            label: 'Perfil',
            icon: 'pi pi-fw pi-user',
            routerLink: ['/perfil'],
            routerLinkActiveOptions: { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' },
          },
          {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/'],
            routerLinkActiveOptions: { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' },
          },
        ],
      },

      {
        label: 'MODULOS',
        items: [{
            label: 'MANTENEDORES',
            items: [
              { label: 'Tipo de carga', icon: 'pi pi-fw pi-database', routerLink: ['/mantenedores/tipo-carga'] },
              { label: 'Tipo de combustión', icon: 'pi pi-fw pi-database', routerLink: ['/mantenedores/tipo-combustion'] },
              { label: 'Tipos de trabajo', icon: 'pi pi-fw pi-briefcase', routerLink: ['/mantenedores/tipos-trabajo'] },
              { label: 'Tipos de vehículo', icon: 'pi pi-fw pi-truck', routerLink: ['/mantenedores/tipos-vehiculo'] },
              { label: 'Tipos de tracción', icon: 'pi pi-fw pi-cog', routerLink: ['/mantenedores/tipos-traccion'] },
            ],
          },
          {
            label: 'REPORTES',
            items: [
              { label: 'Solicitudes', icon: 'pi pi-fw pi-list', routerLink: ['/reportes/solicitudes'] },
              { label: 'Valoraciones', icon: 'pi pi-fw pi-star', routerLink: ['/reportes/valoraciones'] },
              { label: 'Usuarios', icon: 'pi pi-fw pi-users', routerLink: ['/reportes/usuarios'] },
              { label: 'Vehículos', icon: 'pi pi-fw pi-truck', routerLink: ['/reportes/vehiculos'] },
              { label: 'Logs app', icon: 'pi pi-fw pi-exclamation-triangle', routerLink: ['/reportes/logsapp'] },
            ],
          },
          {
            label: 'SEGURIDAD',
            items: [
              { label: 'Tipos de usuario', icon: 'pi pi-fw pi-id-card', routerLink: ['/seguridad/tipos-usuario'] },
              { label: 'Usuarios', icon: 'pi pi-fw pi-users', routerLink: ['/seguridad/usuarios'] },
              { label: 'Roles', icon: 'pi pi-fw pi-shield', routerLink: ['/seguridad/roles'] },
              { label: 'Permisos', icon: 'pi pi-fw pi-key', routerLink: ['/seguridad/permisos'] },
            ],
          }]
      }
    ];
  }
}
